import { Col, message, Row } from 'antd';
import { InboundOrOutboundOrderDetails } from 'components/inbound-outbound-orders/details';
import PdButton from 'components/pd-button';
import queryString from 'query-string';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import OrderActivity from 'services/order';
import OrderPickUpService from 'services/order-pickup';
import { errHandling } from 'utils';

export function InboundOrderDetails() {
  const [orderDetail, setOrderDetail] = useState({});
  const [orderActivity, setOrderActivity] = useState([]);

  const location = useLocation();
  const navigate = useNavigate();

  const { id } = queryString.parse(location.search) || {};

  async function getOrderActivity() {
    try {
      const {
        data: { data },
      } = await OrderActivity.getOrderActivity(id);
      setOrderActivity(data);
    } catch (error) {
      errHandling(error);
    }
  }

  async function confirmArriveOrder() {
    try {
      await OrderPickUpService.confirmArriveOrder(id);
      message.success('Order has arrived');
      navigate('/pickup_points/inbound-order', { replace: true });
    } catch (error) {
      errHandling(error);
    }
  }

  async function getOrderPickUpDetail() {
    try {
      const {
        data: { data },
      } = await OrderPickUpService.getOrderDetails(id);
      setOrderDetail(data);
    } catch (error) {
      errHandling(error);
    }
  }

  useEffect(() => {
    if (id) {
      getOrderPickUpDetail();
      getOrderActivity();
    }
    // eslint-disable-next-line
  }, [id]);

  return (
    <InboundOrOutboundOrderDetails
      orderDetail={orderDetail}
      orderActivity={orderActivity}>
      <Row gutter={[0, 8]}>
        <Col span={24}>
          <PdButton full type="primary" onClick={confirmArriveOrder}>
            Arrived
          </PdButton>
        </Col>
      </Row>
    </InboundOrOutboundOrderDetails>
  );
}
